module.exports = __webpack_public_path__ + "static/media/004.d9667d7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/004.jpg
// module id = 351
// module chunks = 0